import React__default, { createContext, useContext, useMemo } from 'react';
var ExperimentsContext = /*#__PURE__*/createContext(new Set());

function useExperimentsContext(experiment) {
  var experiments = useContext(ExperimentsContext);
  if (experiment === null) return new Set();
  if (experiment) return new Set([experiment]);
  return experiments;
}

var ExperimentsProvider = function ExperimentsProvider(_ref) {
  var experiments = _ref.experiments,
      extendsParentExperiments = _ref.extendsParentExperiments,
      children = _ref.children;
  var experimentsFromParent = useExperimentsContext();
  var value = useMemo(function () {
    var currentExp = new Set(experiments);

    if (extendsParentExperiments) {
      experimentsFromParent.forEach(function (experiment) {
        currentExp.add(experiment);
      });
    }

    return currentExp;
  }, [experiments, experimentsFromParent, extendsParentExperiments]);
  return /*#__PURE__*/React__default.createElement(ExperimentsContext.Provider, {
    value: value
  }, children);
};

export { ExperimentsContext, ExperimentsProvider, useExperimentsContext };